 /*================ Brand Bar Factory
  ========================================*/
  angular
    .module('vppApp')
    .factory('promoTileFactory', promoTileFactory);

    promoTileFactory.$inject = ['$http', '$rootScope', '$log', 'vppConfig', '$state', 'SetLiveSwapService'];

    function promoTileFactory($http, $rootScope, $log, vppConfig, $state, SetLiveSwapService){
      return function(){
        var liveswap = SetLiveSwapService.getLSBrandName();
        if(liveswap){
          var Url = vppConfig.promotTileContentPath + "promoTile-" + $state.current.name + "-liveswap.json";
        } else {
          var Url = vppConfig.promotTileContentPath + "promoTile-" + $state.current.name + ".json";
        }
        var promise = $http.get(Url).then(function successCallback(data){
        return data;
      }, function errorCallback (data){
        return data;
      })

      return promise;
      }
  };